import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpEventType, HttpEvent } from "@angular/common/http";
import { ApiClientService } from "@shared/_services/api-client.service";
import { PreloaderComponent } from '@app/modules/utils/preloader/preloader.component';

@Component({
  selector: 'app-user-themes',
  standalone: true,
  imports: [CommonModule, RouterModule, PreloaderComponent],
  templateUrl: './user-themes.component.html',
  styleUrl: './user-themes.component.css'
})
export class UserThemesComponent {

  public urlPath: string = '';
  public userId: string = '';
  public loading: boolean = false;
  public userDetails: any = {};
  public themes: any[] = [];
  public hasError: boolean = false;
  public errorMsg: string = '';

  constructor(private _apiClientService: ApiClientService) {
    
    this.urlPath = window.location.href;

    console.log(this.urlPath.split('/')[6]);
    this.userId = this.urlPath.split('/')[5];

   }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.userId = this.urlPath.split('/')[5];
    this.getUserDetails();
  }

  public async getUserDetails() {
    this.loading = true;
    (await this._apiClientService.readAllApiService(`admin/itt-user/${this.userId}/detail`)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            //console.log("Users Details ", event.body);
            let data = event.body;
            //if (status == 200) {

            this.userDetails = data;
            console.log(this.userDetails);
            this.themes = data.themes;
          //console.log(this.userDetails);
          //this._userDataService.setData(this.userDetails);
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

}
